import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-arrow-left",
  "use": "svgIcon-arrow-left-usage",
  "viewBox": "0 0 97.285 97.285",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 97.285 97.285\" id=\"svgIcon-arrow-left\"><path d=\"M34.479 13.334L.585 47.229a2 2 0 000 2.828l33.894 33.896c.781.78 2.047.78 2.828 0l9.031-9.028a2.002 2.002 0 000-2.828L31.807 57.561h63.478a2 2 0 002-2V41.726a2 2 0 00-2-2H31.807l14.532-14.533c.75-.75.75-2.078 0-2.828l-9.031-9.031a2 2 0 00-2.829 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol